module.exports = __webpack_public_path__ + "static/media/atypical-pattern-2.0b47ec8d.mp4";